import { render, staticRenderFns } from "./index.vue?vue&type=template&id=535e2d6e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535e2d6e')) {
      api.createRecord('535e2d6e', component.options)
    } else {
      api.reload('535e2d6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=535e2d6e&", function () {
      api.rerender('535e2d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/attractManage/index.vue"
export default component.exports